import React, { useState, useEffect } from 'react';

import CommonImage from '@/components/CommonImage';
import AiLoader from '@/components/AiLoader';
import { printApiError, showTwoDecimalNumber } from '@/utils/Util';
import ApiClient from '@/lib/apiClient';

const AiCost = ({ setShowPredictCost, predictedCostInfo, setPredictedCostInfo, showAiLoader }) => {
	const [showExplanation, setShowExplanation] = useState(false);
	const [similarStyles, setSimilarStyles] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const getSimilarStyles = async () => {
		try {
			setIsLoading(true);
			const params = `?page=0&size=20`;
			const requestBody = {
				productIdList: predictedCostInfo?.productIds
			};
			const { data } = await ApiClient.POST('getManageProducts', requestBody, params);

			const productIdOrder = {};
			predictedCostInfo?.productIds.forEach((id, index) => {
				productIdOrder[id] = index;
			});

			const sortedData = {
				...data,
				data: data.data.sort((a, b) => productIdOrder[a.id] - productIdOrder[b.id])
			};

			setSimilarStyles(sortedData);
			setIsLoading(false);
		} catch (error) {
			printApiError(error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (predictedCostInfo?.productIds) {
			getSimilarStyles();
		}
	}, [predictedCostInfo]);

	const renderDesignList = () => {
		return (
			<>
				{similarStyles?.data?.length > 0 ? (
					<div className="design-list-container d-grid grid-columns-2 gap-3">
						{similarStyles?.data?.map((design) => (
							<div className="design-single-item mb-2 ">
								<div className="single-design-card cursor-default">
									<div className="card-top ">
										<CommonImage
											src={design?.designDocuments[0]?.docUrl}
											className="card-image"
											alt="design"
											isStatic={false}
										/>
									</div>
									<div className="card-content">
										<div className="card-info">
											<p
												className="regular-12 hover-underline weight-500 pt-0 mb-1 cursor-pointer"
												onClick={() => redirectToDesign(design?.id)}
											>
												{design?.referenceNumber}
											</p>
											<ul className="common-list-component addedBy-status">
												<li>
													<span>{design?.addedByName}</span>
												</li>
												{design?.baseAdminPrice && (
													<li>${showTwoDecimalNumber(design?.baseAdminPrice)}</li>
												)}
											</ul>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<div className="d-flex justify-content-center mt-5 pt-5">
						<p className="regular-14 gray_dark_03">No similar styles found</p>
					</div>
				)}
			</>
		);
	};

	const renderExplanation = () => {
		return (
			<div className="explanation-popup">
				<div className="d-flex justify-content-end">
					<CommonImage
						src="/icons/close.svg"
						className="cursor-pointer close-icon"
						onClick={() => setShowExplanation(false)}
					/>
				</div>
				<p className="regular-14 mb-0">{predictedCostInfo?.explanation}</p>
			</div>
		);
	};

	const redirectToDesign = (designId) => {
		window.open(`/collections/list?openDesign=true&productId=${designId}`, '_blank');
	};

	return (
		<div className="ai-cost p-4">
			<p
				className="hide-searched-results regular-14 mb-4 cursor-pointer"
				onClick={() => {
					setShowPredictCost(false);
					setPredictedCostInfo(null);
				}}
			>
				Hide
				<CommonImage src="/icons/down-arrow-gray-dark-01.svg" className="cursor-pointer ml-1" />
			</p>
			{showAiLoader ? (
				<div className="ai-loader-container pt-3">
					<AiLoader />
				</div>
			) : (
				<div className="ai-cost-container">
					<p className="regular-14 mb-1 d-flex align-items-center gap-1">
						<span className="gray_dark_02">Predicted Cost:</span>
						<span className="semibold-14">{predictedCostInfo?.predictedCost}$</span>
						<CommonImage
							src="/icons/info.svg"
							className="cursor-pointer ml-1"
							onClick={() => setShowExplanation(true)}
						/>
					</p>
					<p className="regular-14">
						<span className="gray_dark_02">Estimated Consumption: </span>
						<span className="semibold-14">{predictedCostInfo?.estimatedConsumption}Kg</span>
					</p>
					{showExplanation && renderExplanation()}
				</div>
			)}
			{predictedCostInfo?.productIds && (
				<div className="similar-styles mt-4">
					<p className="semibold-14 mb-2">Similar Styles</p>

					{isLoading ? (
						<div className="d-flex justify-content-center mt-5 pt-5">
							<div className="round-loader"></div>
						</div>
					) : (
						renderDesignList()
					)}
				</div>
			)}
		</div>
	);
};

export default AiCost;
